export const registeredStudiosData = [
  {
    id: 1,
    studioName: "Swift, Green and Mueller",
    studioCity: "Boljevac",
    isStudioVerified: false,
  },
  {
    id: 2,
    studioName: "Heathcote, Balistreri and Schoen",
    studioCity: "Kozova",
    isStudioVerified: true,
  },
  {
    id: 3,
    studioName: "Padberg-MacGyver",
    studioCity: "Lanjaghbyur",
    isStudioVerified: false,
  },
  {
    id: 4,
    studioName: "Marks, Heller and O'Reilly",
    studioCity: "Santa Brigida",
    isStudioVerified: true,
  },
  {
    id: 5,
    studioName: "Marks-D'Amore",
    studioCity: "Dahua",
    isStudioVerified: true,
  },
  {
    id: 6,
    studioName: "Zboncak-Wiegand",
    studioCity: "Purwojoyo",
    isStudioVerified: false,
  },
  {
    id: 7,
    studioName: "Yost-Collins",
    studioCity: "Bayanaūyl",
    isStudioVerified: true,
  },
  {
    id: 8,
    studioName: "Schuppe LLC",
    studioCity: "Kudang",
    isStudioVerified: true,
  },
  {
    id: 9,
    studioName: "Bartell Inc",
    studioCity: "Dongjia",
    isStudioVerified: false,
  },
  {
    id: 10,
    studioName: "Jacobs-O'Kon",
    studioCity: "Mantingantengah",
    isStudioVerified: true,
  },
  {
    id: 11,
    studioName: "Adams Inc",
    studioCity: "Sceaux",
    isStudioVerified: true,
  },
  {
    id: 12,
    studioName: "Mosciski Group",
    studioCity: "Svetlyy",
    isStudioVerified: true,
  },
  {
    id: 13,
    studioName: "Jakubowski LLC",
    studioCity: "Międzyrzecz",
    isStudioVerified: true,
  },
  {
    id: 14,
    studioName: "Herman, Cronin and Blick",
    studioCity: "Iwai",
    isStudioVerified: true,
  },
  {
    id: 15,
    studioName: "Lindgren-Pouros",
    studioCity: "Qixing",
    isStudioVerified: false,
  },
  {
    id: 16,
    studioName: "Metz, Heaney and Hudson",
    studioCity: "Dingyan",
    isStudioVerified: false,
  },
  {
    id: 17,
    studioName: "Herman-Stanton",
    studioCity: "Pocokan Satu",
    isStudioVerified: false,
  },
  {
    id: 18,
    studioName: "Herman, Lockman and Johnston",
    studioCity: "Tongquan",
    isStudioVerified: false,
  },
  {
    id: 19,
    studioName: "Christiansen Group",
    studioCity: "Benito Juarez",
    isStudioVerified: true,
  },
  {
    id: 20,
    studioName: "Braun, Quitzon and Altenwerth",
    studioCity: "Ganting",
    isStudioVerified: false,
  },
  {
    id: 21,
    studioName: "Dickinson-Hudson",
    studioCity: "Kahabe",
    isStudioVerified: true,
  },
  {
    id: 22,
    studioName: "Dickens-Reinger",
    studioCity: "Youssoufia",
    isStudioVerified: true,
  },
  {
    id: 23,
    studioName: "Koepp, Sawayn and Spencer",
    studioCity: "Hekinan",
    isStudioVerified: true,
  },
  {
    id: 24,
    studioName: "Zboncak-Yost",
    studioCity: "Orizari",
    isStudioVerified: false,
  },
  {
    id: 25,
    studioName: "Hyatt, Turcotte and Runolfsson",
    studioCity: "Sawahbaru",
    isStudioVerified: false,
  },
  {
    id: 26,
    studioName: "Trantow-Runolfsson",
    studioCity: "Stockholm",
    isStudioVerified: false,
  },
  {
    id: 27,
    studioName: "Kutch-Ziemann",
    studioCity: "Forninho",
    isStudioVerified: false,
  },
  {
    id: 28,
    studioName: "Robel Inc",
    studioCity: "Jinqiao",
    isStudioVerified: false,
  },
  {
    id: 29,
    studioName: "Lowe, Predovic and Cruickshank",
    studioCity: "Herrán",
    isStudioVerified: true,
  },
  {
    id: 30,
    studioName: "Mante, Braun and Bauch",
    studioCity: "Palikir - National Government Center",
    isStudioVerified: true,
  },
  {
    id: 31,
    studioName: "Willms-Ward",
    studioCity: "Visby",
    isStudioVerified: true,
  },
  {
    id: 32,
    studioName: "Schaden, Bogan and Mante",
    studioCity: "Zhemtala",
    isStudioVerified: false,
  },
  {
    id: 33,
    studioName: "Smitham and Sons",
    studioCity: "Lille",
    isStudioVerified: true,
  },
  {
    id: 34,
    studioName: "Altenwerth, Effertz and Lakin",
    studioCity: "Piedras",
    isStudioVerified: false,
  },
  {
    id: 35,
    studioName: "Lockman Group",
    studioCity: "Krajan Karangsari",
    isStudioVerified: false,
  },
  {
    id: 36,
    studioName: "Willms Inc",
    studioCity: "Betong",
    isStudioVerified: true,
  },
  {
    id: 37,
    studioName: "Berge, Runolfsdottir and Barton",
    studioCity: "‘Ubāl",
    isStudioVerified: true,
  },
  {
    id: 38,
    studioName: "Schaefer-Cummerata",
    studioCity: "Chum Phae",
    isStudioVerified: true,
  },
  {
    id: 39,
    studioName: "Stanton, Schuppe and Rutherford",
    studioCity: "Cleveland",
    isStudioVerified: false,
  },
  {
    id: 40,
    studioName: "Upton Inc",
    studioCity: "Riga",
    isStudioVerified: true,
  },
  {
    id: 41,
    studioName: "Wiza, Sawayn and Jerde",
    studioCity: "Shazhouba",
    isStudioVerified: false,
  },
  {
    id: 42,
    studioName: "Mohr-Mitchell",
    studioCity: "Prao",
    isStudioVerified: true,
  },
  {
    id: 43,
    studioName: "Mann-Pfeffer",
    studioCity: "Älvsjö",
    isStudioVerified: false,
  },
  {
    id: 44,
    studioName: "Kemmer Group",
    studioCity: "Vyshneve",
    isStudioVerified: false,
  },
  {
    id: 45,
    studioName: "Ratke Group",
    studioCity: "Henghe",
    isStudioVerified: false,
  },
  {
    id: 46,
    studioName: "Bailey Inc",
    studioCity: "‘Afīf",
    isStudioVerified: true,
  },
  {
    id: 47,
    studioName: "Bednar, Mraz and Casper",
    studioCity: "Kraljevo",
    isStudioVerified: false,
  },
  {
    id: 48,
    studioName: "Roob-Robel",
    studioCity: "Castelo",
    isStudioVerified: true,
  },
  {
    id: 49,
    studioName: "Fahey, Weber and Schroeder",
    studioCity: "San Buenaventura",
    isStudioVerified: false,
  },
  {
    id: 50,
    studioName: "Blanda and Sons",
    studioCity: "San Felipe",
    isStudioVerified: true,
  },
];
